/**
 * Weather overlay tokens aligned with public-map auth / panel design system.
 * Surfaces: white/gray-900, borders gray-200/700, primary-500 actions, rounded-xl.
 */

/** Floating panel on map (matches MapControlsFAB / profile panels). */
export const WEATHER_PANEL =
  'rounded-xl border border-gray-200 bg-white/95 shadow-lg backdrop-blur-xl dark:border-gray-700/50 dark:bg-gray-900/95 dark:shadow-black/40 dark:ring-1 dark:ring-gray-700/50';

/** Compact card / pill on map. */
export const WEATHER_PILL =
  'rounded-xl border border-gray-200 bg-white shadow-md dark:border-gray-700 dark:bg-gray-800';

/** Center modal shell (auth-style surfaces). */
export const WEATHER_MODAL =
  'overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-2xl dark:border-gray-700 dark:bg-gray-900';

export const WEATHER_MODAL_SCRIM =
  'fixed inset-0 z-[60] flex items-center justify-center overflow-y-auto bg-black/40 p-4 sm:p-6 dark:bg-black/55';

/** Comfortable reading width for weather modals — never spans full viewport on desktop. */
export const WEATHER_MODAL_WIDTH = 'mx-auto w-[min(100%,28rem)] shrink-0';

export const WEATHER_TITLE = 'text-sm font-semibold text-gray-900 dark:text-white';

export const WEATHER_HEADING = 'text-xl font-semibold text-gray-900 dark:text-white';

export const WEATHER_LABEL =
  'text-[10px] font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400';

export const WEATHER_MUTED = 'text-xs text-gray-500 dark:text-gray-400';

export const WEATHER_BODY = 'text-sm leading-relaxed text-gray-700 dark:text-gray-300';

export const WEATHER_BTN_PRIMARY =
  'rounded-lg bg-primary-500 px-4 py-2.5 text-sm font-medium text-white transition-colors hover:bg-primary-600 disabled:opacity-60';

export const WEATHER_BTN_SECONDARY =
  'rounded-lg border border-gray-200 bg-white px-4 py-2.5 text-sm font-medium text-gray-700 transition-colors hover:bg-gray-50 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-200 dark:hover:bg-gray-750';

export const WEATHER_BTN_GHOST =
  'rounded-lg p-2 text-gray-400 transition-colors hover:bg-gray-100 hover:text-gray-600 dark:hover:bg-gray-800 dark:hover:text-gray-300';

export const WEATHER_INPUT =
  'w-full rounded-lg border border-gray-200 bg-white px-3 py-2.5 text-sm text-gray-900 outline-none transition-colors placeholder:text-gray-400 focus:border-primary-500 dark:border-gray-700 dark:bg-gray-800 dark:text-white dark:placeholder:text-gray-500';

export const WEATHER_ICON_CIRCLE =
  'flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-primary-100 dark:bg-primary-900/40';

/** Selected map-layer ring (primary, same as auth focus). */
export const WEATHER_SELECTED = 'ring-2 ring-primary-500 border-primary-500 dark:ring-primary-400 dark:border-primary-400';

/** Full-width gradient CTA for daily forecast emails. */
export const WEATHER_BTN_SUBSCRIBE =
  'w-full min-h-[2.75rem] py-3 px-4 text-sm font-semibold bg-gradient-to-r from-emerald-500 to-cyan-500 text-white rounded-xl inline-flex items-center justify-center gap-2 hover:opacity-90 active:opacity-95 transition-opacity shadow-sm touch-manipulation';

export const WEATHER_BTN_SUBSCRIBED =
  'w-full min-h-[2.75rem] py-3 px-4 text-sm font-semibold rounded-xl inline-flex items-center justify-center gap-2 border border-emerald-300 bg-emerald-50 text-emerald-800 dark:border-emerald-700 dark:bg-emerald-950/50 dark:text-emerald-200';

export const WEATHER_BTN_DISMISS =
  'w-full min-h-[2.75rem] py-2.5 px-4 text-sm font-medium text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-xl transition-colors touch-manipulation';
